import { createAction } from '@'
import { getAuth, loginErrorHandle } from '@misc'
import axios from 'axios'
import { $permissions } from '../stores'

const ENDPOINT = process.env.REACT_APP_API_URL

export default createAction('GetPermissions', async () => {
    try {
        const auth = getAuth()

        const res = await axios({
            url: `${ENDPOINT}/permissions`,
            method: 'GET',
            headers: { 'Content-Type': 'application/json', ...auth }
        })

        $permissions.setState(() => (res && res.data) || [])
    } catch (e) {
        loginErrorHandle(e)
        console.error(e)
    }
})
